import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../api';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Verifying your email...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('Invalid verification link');
      return;
    }

    api
      .post('/auth/verify-email', { token })
      .then(() => setStatus('Email verified successfully. You can now enroll in courses.'))
      .catch(err => setStatus(err.response?.data?.message || 'Verification failed'));
  }, [searchParams]);

  return (
    <div className="container py-5">
      <h2>Email Verification</h2>
      <p>{status}</p>
      <Link to="/login" className="btn btn-primary">
        Go to login
      </Link>
    </div>
  );
};

export default VerifyEmailPage;
